import LangLink from '../../../../components/common/LangLink';
import { motion } from 'framer-motion';
import { useTheme } from '../../../../context/ThemeContext';

const HeroLanding = ({ language }) => {
    const fr = language === 'fr';
    const { theme } = useTheme();
    const themeStr = theme === 'dark' ? 'dark' : 'light';
    const heroBg = `/img/landing/hero_background_${themeStr}.webp`;

    const titleLine1 = fr ? 'Assure' : 'Ensure';
    const titleLine2 = fr ? 'ton succès' : 'your success';
    const subtitle = fr
        ? 'Comme plus de 20 000 pilotes, prépare-toi aux examens de Transports Canada avec nizus.'
        : 'Join the 20,000+ pilots who have prepared for their Transport Canada exams with nizus.';
    const ctaLabel = fr ? 'Commencer gratuitement' : 'Start for free';

    return (
        <section className="relative bg-white dark:bg-[#0f0f0f] text-white overflow-hidden">
            {/* Background sky image — same asset for both themes; bottom fade adapts to base color
                so the hero blends smoothly into the next section. */}
            <div className="absolute inset-0 pointer-events-none">
                <img
                    key={heroBg}
                    src={heroBg}
                    alt=""
                    aria-hidden
                    className="absolute inset-0 w-full h-full object-cover object-top"
                />
                {/* Bottom fade to section base color (white in light, near-black in dark) */}
                <div className="absolute bottom-0 left-0 right-0 h-[35%] bg-gradient-to-t from-white dark:from-[#0f0f0f] to-transparent" />
            </div>

            {/* Content */}
            <div className="relative max-w-[1440px] mx-auto">
                <div className="relative z-10 flex flex-col items-center text-center px-6 pt-28 pb-20 md:pt-[140px] md:pb-32 md:min-h-[640px]">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="flex flex-col items-center"
                    >
                        <h1 className="font-['Rethink_Sans',sans-serif] font-normal text-white text-center text-5xl leading-[0.95] tracking-[-2px] md:text-[72px] md:leading-[68px] md:tracking-[-3px] mb-5 md:mb-6 [text-shadow:0_2px_8px_rgba(0,0,0,0.25)]">
                            <span className="block">{titleLine1}</span>
                            <span className="block">{titleLine2}</span>
                        </h1>

                        <p className="font-['Rethink_Sans',sans-serif] font-normal text-white text-base leading-snug md:text-[17px] md:leading-[23px] max-w-[420px] text-center mb-7 md:mb-9 [text-shadow:0_1px_4px_rgba(0,0,0,0.35)]">
                            {subtitle}
                        </p>

                        <LangLink
                            to="/signup"
                            className="inline-flex items-center justify-center bg-white text-[#0061fe] font-['Manrope',sans-serif] font-semibold text-[13px] px-[26px] py-[18px] rounded-full hover:bg-white/90 active:scale-[0.98] transition-all shadow-lg shadow-black/20"
                        >
                            {ctaLabel}
                        </LangLink>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default HeroLanding;
